import { render, staticRenderFns } from "./ProjectMediacontactPartnerFeatureList.vue?vue&type=template&id=67d15c38"
import script from "./ProjectMediacontactPartnerFeatureList.vue?vue&type=script&lang=js"
export * from "./ProjectMediacontactPartnerFeatureList.vue?vue&type=script&lang=js"
import style0 from "./ProjectMediacontactPartnerFeatureList.vue?vue&type=style&index=0&id=67d15c38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports